import { MessageTemplatesState } from "@idw-types/state/message-templates-state";
import { MessageTemplatesActions, MessageTemplatesActionTypes } from "@redux/actions/message-templates-actions";

export const initialMessageTemplatesState: MessageTemplatesState = {
    messageTemplates: {
        isLoading: false,
        messageTemplates: null
    }
};

export const messageTemplatesReducer = (
    state: MessageTemplatesState = initialMessageTemplatesState,
    action: MessageTemplatesActions
): MessageTemplatesState => {
    switch (action.type) {
        // Email Templates
        case MessageTemplatesActionTypes.SET_MESSAGE_TEMPLATES_LOADING:
            return {
                ...state,
                messageTemplates: {
                    ...(action.payload.isLoading
                        ? { ...initialMessageTemplatesState.messageTemplates }
                        : { ...state.messageTemplates }),
                    isLoading: action.payload.isLoading
                }
            };
        case MessageTemplatesActionTypes.SET_MESSAGE_TEMPLATES:
            return {
                ...state,
                messageTemplates: {
                    ...state.messageTemplates,
                    messageTemplates: action.payload.messageTemplates,
                    isLoading: false
                }
            };
        case MessageTemplatesActionTypes.ADD_MESSAGE_TEMPLATE:
            return {
                ...state,
                messageTemplates: {
                    ...state.messageTemplates,
                    messageTemplates: state.messageTemplates.messageTemplates
                        ? [...state.messageTemplates.messageTemplates, action.payload.messageTemplate]
                        : [action.payload.messageTemplate]
                }
            };
        default:
            return state;
    }
};